import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface User {
  id: string;
  name: string;
  whatsapp: string;
}

interface DeleteUsersModalProps {
  users: User[];
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  isDeleting: boolean;
}

export function DeleteUsersModal({ users, onConfirm, onCancel, isDeleting }: DeleteUsersModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-lg w-full">
        <div className="p-6 border-b border-gray-200 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <AlertTriangle className="text-red-600" size={24} />
            <h3 className="text-xl font-semibold text-gray-900">
              Confirmar Exclusão
            </h3>
          </div>
          <button
            onClick={onCancel}
            disabled={isDeleting}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors disabled:opacity-50"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        <div className="p-6">
          <div className="mb-6">
            <p className="text-gray-700 mb-4">
              Você está prestes a excluir {users.length} {users.length === 1 ? 'usuário' : 'usuários'}:
            </p>
            <div className="bg-gray-50 rounded-lg p-4 max-h-40 overflow-y-auto">
              {users.map(user => (
                <div key={user.id} className="mb-2 last:mb-0">
                  <p className="font-medium text-gray-900">{user.name}</p>
                  <p className="text-sm text-gray-500">{user.whatsapp}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <p className="text-red-700 font-medium mb-2">⚠️ Atenção</p>
            <p className="text-red-600 text-sm">
              Esta ação excluirá permanentemente todos os dados relacionados a {users.length === 1 ? 'este usuário' : 'estes usuários'}, incluindo:
            </p>
            <ul className="text-red-600 text-sm mt-2 list-disc list-inside">
              <li>Alertas e registros</li>
              <li>Histórico de vendas</li>
              <li>Indicações e comissões</li>
              <li>Dados de acesso</li>
            </ul>
            <p className="text-red-700 font-medium mt-4">
              Esta ação não pode ser desfeita!
            </p>
          </div>

          <div className="flex justify-end gap-3">
            <button
              onClick={onCancel}
              disabled={isDeleting}
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              disabled={isDeleting}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50"
            >
              {isDeleting ? 'Excluindo...' : 'Confirmar Exclusão'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}